<template>
        <a id="show-modal" @click="showModal = true">
            Comp Id: 
            <span v-show="compId">{{compId}}</span>
            <strong v-show="!compId">Set Computer Id</strong>
        </a>
        <div class="modal-mask" v-if="showModal" @close="showModal = false">
          <div class="modal-wrapper">
            <div class="modal-container">

              <div class="modal-header">
                  <h3>Select Computer Id</h3>
              </div>

              <div class="modal-body">
                    <select name="compId" id="compId" v-model="newCompId" class="form-control">
                        <option value="">Change to</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="G1">G1</option>
                        <option value="G2">G2</option>
                        <option value="G3">G3</option>
                        <option value="G4">G4</option>
                        <option value="G5">G5</option>
                        <option value="StudySite">Study Site</option>
                    </select>
              </div>

              <div class="modal-footer">
                <button class="btn btn-default" @click="setComputerId();$emit('close')">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
</template>
<script>
    export default {
        name: 'computerid',
        props: {
            compId: [String, Number],
            showModal: Boolean
          },
        data() {
            return {
              showModal: this.showModal,
              compId: this.compId,
              newCompId: this.newCompId
            }
          },
        setup: function (props, context) {
            // const newCompId = props.compId;
            // const showModal = props.showModal;
            //const compId = props.compId;
            // return {newCompId, showModal, compId};
        },
        methods: {
            setComputerId: function () {
                
                axios.get('/api/computer-id/'+this.newCompId)
                    .then(function (response) {
                        this.compId = this.newCompId;
                        console.log(response);
                        this.fireClosed();
                    }.bind(this));
            },
            getComputerId: function () {
                axios.get('/api/computer-id')
                    .then(function (response) {
                        console.log(response);
                    });
            },
            fireClosed: function () {
              this.showModal = false;
            }
        },
        mounted: function () {
            //newCompId = this.compId;
        }
    }
</script>
<style>
    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
    }

    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    .modal-container {
      width: 300px;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
      margin-top: 0;
    }

    .modal-body {
      margin: 20px 0;
    }

    .modal-default-button {
      float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
      opacity: 0;
    }

    .modal-leave-active {
      opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }
</style>